<template>
    <div class="logistics-info-box">
      <div class="nav-bar">
        <view
          class="navItem"
          v-for="item in logisticsTitle"
          :key="item.id"
          @click="selectFunction(item.id)"
          :class="{ choseItem: logisticsId == item.id }"
        >
          {{ item.text }}
        </view>
      </div>
      <div class="Fixedsource-list">
        <!-- 调试信息 -->
        <div v-if="dataList.length === 0" style="text-align: center; padding: 20px; color: #999;">
          正在加载工厂企业数据...
        </div>
        <div
          v-for="item in currentPageData"
          :key="item.id"
          class="company-card"
          @click="() => handleViewDetail(item)"
        >
          <img :src="item.img" class="company-img" alt="企业图片" />
          <div class="company-info">
            <div class="company-header">
              <span class="company-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { getLogisticsList } from '@/apis/modules/logistics/index.js';
  import { ElMessage } from 'element-plus';

  export default {
    name: 'FactoryInfo',
    data() {
      return {
        logisticsTitle: [
          { id: 1, text: '国内物流' },
          { id: 2, text: '国际物流' },
          { id: 6, text: '工厂企业' },
          { id: 3, text: '实时车源' },
          { id: 4, text: '实时货源' },
          // { id: 5, text: '物流园区' }
        ],
        logisticsId: 6,
        dataList: []
      };
    },
    computed: {
      currentPageData() {
        return this.dataList.slice(0, 6);
      }
    },
    methods: {
      selectFunction(id) {
        if (id === 2 || id === 3) {
          ElMessage({ message: '该功能未开放，敬请期待！', type: 'warning' });
          return;
        }
        // 如果点击的是当前已选中的tab，不需要重新emit
        if (this.logisticsId !== id) {
          this.logisticsId = id;
          this.$emit('selectLogistics', id);
        }
      },
      handleViewDetail(item) {
        this.$router.push({
          name: 'FactoryView',
          query: {
            id: item.id
          }
        });
      },
      async fetchList() {
        try {
          const params = { pageNo: 1, pageSize: 6 };
          const res = await getLogisticsList(params);
          if (res && res.statusCode === 20000 && res.data && Array.isArray(res.data.records)) {
            this.dataList = res.data.records.map(item => ({
              id: item.qiyeId,
              name: item.name,
              img: item.logo
            }));
            console.log('处理后的工厂企业数据:', this.dataList);
          } else {
            console.warn('API返回数据格式不符合预期:', res);
            this.dataList = [];
          }
        } catch (e) {
          console.error('获取工厂企业列表失败', e);
          this.dataList = [];
        }
      }
    },
    mounted() {
      console.log('FactoryInfo组件已挂载');
      this.fetchList();
    }
  };
  </script>

  <style scoped lang="scss">
  .logistics-info-box {
    width: 924px;
    min-height: 880px;
    background: white;
    box-sizing: border-box;
    padding: 8px 24px 0px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .nav-bar {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 24px;
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: rgba(0, 27, 81, 0.4);
      box-sizing: border-box;
      margin-bottom: 24px;
      .navItem {
        display: flex;
        align-items: center;
        height: 64px;
        margin-right: 80px;
        padding-bottom: 4px;
        color: rgba(0, 27, 81, 0.4);
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        cursor: pointer;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: normal;
        color: rgba(0, 27, 81, 0.4);
      }
      .choseItem{
        border-bottom: 6px solid #001B51;
        color: #001B51;
        font-weight: bold;
      }
    }
  }
  .Fixedsource-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  .company-card {
    position: relative;
    width: 434px;
    min-height: 220px;
    background: linear-gradient(180deg, #f1f7ff 0%, #f1f7ff 100%);
    border: 1px solid #e6eaf2;
    box-shadow: 0 2px 8px 0 rgba(0, 23, 77, 0.08);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 15px;
    transition: box-shadow 0.2s, background 0.2s;
    cursor: pointer;
  }
  .company-card:hover {
    background: linear-gradient(180deg, #f1f6ff 0%, #ffffff 100%);
    box-shadow: 0px 10px 16px 0px rgba(0, 27, 81, 0.2);
  }
  .company-card::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background: #076aff;
    opacity: 0;
    transition: opacity 0.2s;
  }
  .company-card:hover::after {
    opacity: 1;
  }
  .company-img {
    width: 402px;
    height: 160px;
    object-fit: cover;
    background: #f6f8fa;
    margin-bottom: 8px;
  }
  .company-info {
    padding: 0 0 0 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .company-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .company-name {
    font-size: 16px;
    font-weight: bold;
    color: #001b51;
    margin-bottom: 0;
  }
  </style>
